import { render, staticRenderFns } from "./background.component.vue?vue&type=template&id=6247f05c&scoped=true&"
import script from "./background.component.vue?vue&type=script&lang=js&"
export * from "./background.component.vue?vue&type=script&lang=js&"
import style0 from "./background.component.vue?vue&type=style&index=0&id=6247f05c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247f05c",
  null
  
)

export default component.exports